/**
 * Client API pour le profil utilisateur complet
 * Agrège les données User + School
 */
import { HttpClient } from '@sphere/shared/data-access/http';
import type { CompleteUserProfile } from '@sphere/user/domain';

const BASE_PATH = '/profile';

export const profileClient = {
  /**
   * Récupère le profil complet de l'utilisateur connecté
   */
  async getMyProfile(): Promise<CompleteUserProfile> {
    const { data } = await HttpClient.get<CompleteUserProfile>(
      `${BASE_PATH}/me`
    );
    return data;
  },

  /**
   * Récupère le profil complet d'un utilisateur spécifique
   */
  async getUserProfile(userId: string): Promise<CompleteUserProfile> {
    const { data } = await HttpClient.get<CompleteUserProfile>(
      `${BASE_PATH}/${userId}`
    );
    return data;
  },
};
